import React from 'react';

interface FavoritesSectionProps {
  onButtonClick: () => void;
}

const FavoritesSection: React.FC<FavoritesSectionProps> = ({ onButtonClick }) => {
  return (
    <section className="relative text-white py-16 overflow-hidden">
      {/* Background image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/Group40@2x.jpg)',
          filter: 'blur(2px)',
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-teal-600 bg-opacity-80"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4">
        <div className="text-center">
          <h2 className="text-3xl font-bold mb-4">Favoritos</h2>
          
          <div className="mb-8">
            <h3 className="text-2xl font-semibold mb-4">Aún no tienes favoritos</h3>
            <p className="text-lg mb-8 max-w-3xl mx-auto">
              Da clic en ELEGIR FAVORITOS para agregar los servicios más utilizados en tu pantalla de inicio.
            </p>
            
            <button 
              onClick={onButtonClick}
              className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
            >
              Elegir favoritos
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FavoritesSection;